export default __webpack_public_path__ + "static/media/logo_sidebar.29bc49a5.png";